import { render, staticRenderFns } from "./mb_message.vue?vue&type=template&id=6313023f&scoped=true&"
import script from "./mb_message.vue?vue&type=script&lang=js&"
export * from "./mb_message.vue?vue&type=script&lang=js&"
import style0 from "./mb_message.vue?vue&type=style&index=0&id=6313023f&prod&lang=css&"
import style1 from "./mb_message.vue?vue&type=style&index=1&id=6313023f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6313023f",
  null
  
)

export default component.exports